import { graphql } from '@/gql/graphql';
import { ChatHomeListItemFragment } from './ChatHomeListItem.utils';

export const CHAT_LIST_PAGE_SIZE = 25;

type ChatListCursor = {
  id: string;
  last_message_at: string | null;
};

export function getChatCursorWhere(
  after: ChatListCursor,
): ReturnType<typeof graphql.scalar<'chat_bool_exp'>> {
  if (after.last_message_at === null) {
    return {
      _or: [
        {
          id: { _lt: after.id },
          last_message_at: { _is_null: true },
        },
      ],
    };
  }

  return {
    _or: [
      { last_message_at: { _lt: after.last_message_at } },
      {
        id: { _lt: after.id },
        last_message_at: { _eq: after.last_message_at },
      },
      { last_message_at: { _is_null: true } },
    ],
  };
}

export const GetChatHomePage = graphql(/* GraphQL */ `
  query GetChatHomePage($where: chat_bool_exp!, $limit: Int!) {
    chat_home(
      limit: $limit
      where: $where
      order_by: [{ last_message_at: desc_nulls_last }, { id: desc }]
    )
      @_cursorPagination(
        cursorArgument: "last_message_at"
        cursorExclusivePredicateArgument: "_or"
      )
    {
      id
      last_message_at
      ...ChatHomeListItem
    }
  }
`, [ChatHomeListItemFragment]);
